// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__7hom+","navigation__list":"Navigation_navigation__list__kPtFt"};